module.exports = __webpack_public_path__ + "static/easyeducation-extraimg3-min-1a5db8b899bffbbcf6590a3cce33a714.jpg";